import axios from 'axios';
import {
  GET_LOYALTY,
  CREATE_LOYALTY,
  ADD_SUBSCRIPTION,
  EDIT_LOYALTY,
  RESET_LOYALTY,
  DEACTIVATE_LOYALTY,
  REACTIVATE_LOYALTY,
  UNION_CATEGORIES_AND_ITEMS,
  UNION_ITEM_VARIANTS,
} from './constants';

function commonReject(error) {
  let errorObj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      errorObj = new Error(data.errors);
    } else if (data.message) {
      errorObj = new Error(data.message);
    } else {
      errorObj = new Error(error.message);
    }
  } else {
    errorObj = new Error(error.message);
  }
  return Promise.reject(errorObj);
}

export function getLoyalty() {
  return axios.get(GET_LOYALTY()).catch(commonReject);
}

export function createLoyalty(data) {
  return axios.post(CREATE_LOYALTY(), data).catch(commonReject);
}

export function editLoyalty(programId, data) {
  return axios.put(EDIT_LOYALTY(programId), data).catch(commonReject);
}

export function resetLoyalty(programId, data) {
  return axios.patch(RESET_LOYALTY(programId), data).catch(commonReject);
}

export function deactivateLoyalty(programId) {
  return axios.patch(DEACTIVATE_LOYALTY(programId)).catch(commonReject);
}

export function reactivateLoyalty(programId, reset) {
  let url = REACTIVATE_LOYALTY(programId);
  if (reset) {
    url = `${url}?reset=${reset.reset}`;
  }
  return axios.patch(url).catch(commonReject);
}

export function addSubscription() {
  return axios
    .put(
      ADD_SUBSCRIPTION,
      {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        feature_name: 'Loyalty',
      },
      { withCredentials: true }
    )
    .catch(commonReject);
}

export function getUnionCategoriesAndItems(outletId, outletIds) {
  const request = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    outlet_ids: outletIds,
  };
  return axios.post(UNION_CATEGORIES_AND_ITEMS, request, {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    params: { outlet_id: outletId },
    withCredentials: true,
  });
}

export function getUnionItemVariants(itemName, outletId, outletIds) {
  const request = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    item_name: itemName,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    outlet_ids: outletIds,
  };
  return axios.post(UNION_ITEM_VARIANTS, request, {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    params: { outlet_id: outletId },
    withCredentials: true,
  });
}
